import React from 'react';
import { EqCondition, useFilterContext, Filter } from 'framework/list';
import { FilterCondition } from 'framework/types';
import { DefaultDropdownProps, Dropdown } from 'framework/form';

interface EmployeeProbationFilterProps extends DefaultDropdownProps {
  value?: string;
}

const EmployeeProbationFilter = (props: EmployeeProbationFilterProps) => {
  const { source } = props;
  const { filterBy } = useFilterContext();

  const handleChange = (data: Filter = {}) => {
    const value = data[source][FilterCondition.EQ];

    filterBy({
      [source]: {
        [FilterCondition.EQ]: value === 'true',
      },
    });
  };

  return (
    <EqCondition {...props} onChangeCallback={handleChange}>
      <Dropdown {...props} placeholder="Select probation" options={[{ value: 'true', label: 'Active' }]} />
    </EqCondition>
  );
};

export default EmployeeProbationFilter;
